import { useEffect, useState } from 'react'
import { Text } from '@cinch-labs/design-system'

import styles from './mobile-app-footer.module.css'

export const MobileAppFooter = () => {
  const [year, setYear] = useState<number | null>(null)

  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])
  return (
    <footer className={styles.footerContainer}>
      <Text element="p" fontSize="s" fontWeight="bold" lineHeight="body">
        New cars are sold by Marshall Motor Group, who will also arrange any
        finance for those cars.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        &copy; {year || ''} Marshall Motor Group
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Registered Office c/o Marshall Volkswagen Milton Keynes, Greyfriars
        Court, Milton Keynes, Buckinghamshire, MK10 0BN.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Registered in England Number 00295579 | VAT Reg. No: 213209019
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Marshall Motor Group Limited is authorised and regulated by the
        Financial Conduct Authority. Our Firm Reference Number is 310503.
        Details of our permissions and trading names can be checked via the FCA
        register https://register.fca.org.uk/s/
      </Text>
      <Text element="p" fontSize="s" fontWeight="bold" lineHeight="body">
        Used cars are sold by cinch cars limited.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        Cinch Cars Limited is an appointed representative of ITC Compliance
        Limited which is authorised and regulated by the Financial Conduct
        Authority (their registration number is 313486). Permitted activities
        include advising on and arranging general insurance contracts and acting
        as a credit broker not a lender.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        We can introduce you to a limited number of finance providers. We do not
        charge fees for our Consumer Credit services. We typically receive a
        payment(s) or other benefits from finance providers should you decide to
        enter into an agreement with them, typically either a fixed fee or a
        fixed percentage of the amount you borrow. The payment we receive may
        vary between finance providers and product types. The payment received
        does not impact the finance rate offered.
      </Text>
      <Text element="p" fontSize="s" fontWeight="light" lineHeight="body">
        All finance applications are subject to status, terms and conditions
        apply, UK residents only, 18&apos;s or over, Guarantees may be required.
      </Text>
    </footer>
  )
}
